import React from "react";
import ReactModal from "react-modal";

export interface CommentsModalProps {
  isOpen: boolean
  onRequestClose: () => void
  children: React.ReactNode
  className?: string
  style?: object
  shouldCloseOnOverlayClick?: boolean
  shouldFocusAfterRender?: boolean
  contentLabel?: string
}

export function CommentsModal({isOpen, onRequestClose, children, className, style, shouldCloseOnOverlayClick, shouldFocusAfterRender, contentLabel}: CommentsModalProps) {
  return <ReactModal
    // The embed does not own the host page, so it must not mark the publisher's content `aria-hidden`.
    ariaHideApp={false}
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    shouldCloseOnEsc={true}
    shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
    shouldFocusAfterRender={shouldFocusAfterRender}
    // The iOS/mobile scroll lock, applied to body/html while the modal is open.
    bodyOpenClassName="sm:tik4-body--modal-open-scroll"
    htmlOpenClassName="tik4-html--modal-open sm:tik4-html--modal-open-scroll"
    portalClassName="tik4-modal tik4-modal--bottom sm:tik4-modal--right lg:tik4-modal--right"
    className={{
      base: `tik4-modal__content tik4-modal__content--comments ${className ?? ''}`,
      afterOpen: 'tik4-modal__content--after-open',
      beforeClose: 'tik4-modal__content--before-close'
    }}
    overlayClassName={{
      base: 'tik4-modal__overlay tik4-modal__overlay--comments',
      afterOpen: 'tik4-modal__overlay--after-open',
      beforeClose: 'tik4-modal__overlay--before-close'
    }}
    style={style}
    contentLabel={contentLabel}
  >
    {children}
  </ReactModal>
}

export default CommentsModal;